import React from 'react';
import { AppProvider } from './src/context';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
// Style imports
import "@styles/main.scss"

export const wrapRootElement = ({ element }) => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.GATSBY_GOOGLE_RECAPTCHA_SITE_KEY}>
    <AppProvider>{element}</AppProvider>
  </GoogleReCaptchaProvider>
);
